import { Module } from 'shared/core';
import { Injectable } from 'injection-js';
import { FlexTable } from 'shared/lib';

@Injectable()
export class OrdersModule extends Module {
  private startReturn: JQuery = $('.startReturn');
  private startReturnTrigger: JQuery = $('.startReturnTrigger');
  private startReturnCancel: JQuery = $('.startReturnCancel');
  private hideAtReturnStarted: JQuery = $('.hideAtReturnStarted');
  private returnsSubOrderSubtotals: JQuery = $('.order-suborders-panel-heading-subtotal');
  private returnItemCheckbox: JQuery = $('.returnItemCheckbox');
  private orderItems: JQuery = $('.orderItems');
  private returnableItems: JQuery = $('.returnableItems');
  private orderStatusFilter: JQuery = $('.order-status-filter');
  private activeAmendmentsFilter: JQuery = $('a.order-amendments-filter.active');
  private amendmentsFilter: JQuery = $('a.order-amendments-filter');
  private amendmentOrderLink: JQuery = $('a.amendmentOrderLink');

  private started = false;

  public init(): void {
    new FlexTable('sm');
    if ($('.returns').data('show-returns') == true) {
      this.validateReturn();
    }
    this.filterOrder();
    this.startReturnTrigger.on('click', () => this.toggleReturn());
    this.startReturnCancel.on('click', () => this.toggleReturn());
    this.returnItemCheckbox.on('click', () => this.validateReturn());
    this.orderStatusFilter.on('change', (e) => this.filterStatus(e));
    this.activeAmendmentsFilter.on('click', (e) => this.filterOrderAmendments(e));
    this.amendmentsFilter.on('click', (e) => this.filterOrderAmendments(e));
    this.amendmentOrderLink.on('click', (e) => this.filterOnItemRow(e));
  }

  private toggleReturn(): void {
    this.startReturn.toggleClass('visible');
    this.startReturnTrigger.toggleClass('hidden');
    this.hideAtReturnStarted.toggleClass('hidden');
    this.orderItems.toggleClass('hidden');
    this.returnableItems.toggleClass('hidden');
    this.returnsSubOrderSubtotals.toggleClass('hidden');
    this.started = !this.started;

    if (this.started) {
      this.validateReturn();
    }
  }

  private validateReturn(): void {
    const checked = this.returnItemCheckbox.filter(':checked').length;
    const validation = checked > 0 ? false : 'disabled';
    this.startReturn.prop('disabled', validation);
  }

  private hideSubOrderRow(): void {
    let subOrderRows = $('.order-suborders-panel');

    subOrderRows.each((_, sub_order_row) => {
      let oiRows = $(sub_order_row).find('.flex-tr:not(.hidden)');

      if (oiRows.length == 0) {
        $(sub_order_row).addClass('hidden');
      } else {
        $(sub_order_row).removeClass('hidden');
      }
    });
  }

  private filterOrder(): { selectedDispatchedStatus: any, selectedAmendment: any, selectedAmendmentQrCode: any, selectedAmendmentLabel: boolean } {
    let selectedDispatchedStatus = this.orderStatusFilter.val();
    let selectedAmendment = $('a.order-amendments-filter.active').data('amendment');
    let selectedAmendmentQrCode = $('a.order-amendments-filter.active').data('qrCode');
    let selectedAmendmentLabel = $('a.order-amendments-filter.active').data('label');

    return {
      selectedDispatchedStatus: selectedDispatchedStatus,
      selectedAmendment: selectedAmendment,
      selectedAmendmentQrCode: selectedAmendmentQrCode,
      selectedAmendmentLabel: selectedAmendmentLabel
    };
  }

  private filterStatus(e): void {
    e.preventDefault();

    let selectedDispatchedStatus = this.filterOrder().selectedDispatchedStatus;
    let selectedAmendment = this.filterOrder().selectedAmendment;

    let order_item_rows = $('.order-suborders-td-product');

    if (selectedDispatchedStatus == 'all' && selectedAmendment == 'original-order') {
      this.showAllItems();
    } else {
      order_item_rows.each((_, order_item_row) => {
        this.filterAmendedDetails(selectedDispatchedStatus, selectedAmendment);
        let showRow = this.showRow(selectedDispatchedStatus, selectedAmendment, order_item_row);

        if (showRow == true) {
          $(order_item_row).closest('.flex-tr').removeClass('hidden');
        } else {
          $(order_item_row).closest('.flex-tr').addClass('hidden');
        }
      });
    }

    this.hideSubOrderRow();
  }

  private filterOrderAmendments(e): void {
    e.preventDefault();
    this.focusOrderLink($(e.target).data('amendment'));

    let selectedDispatchedStatus = this.filterOrder().selectedDispatchedStatus;
    let selectedAmendment = this.filterOrder().selectedAmendment;
    let selectedAmendmentQrCode = this.filterOrder().selectedAmendmentQrCode;
    let selectedAmendmentLabel = this.filterOrder().selectedAmendmentLabel;

    let order_item_rows = $('.order-suborders-td-product');

    let shippingLabelsContainer = $('.amendmentShippingLabels');

    if (selectedAmendment == 'original-order') {
      shippingLabelsContainer.addClass('hidden');
      $('.current-price,.price-offer').removeClass('hidden');
      $('.amendment-price').addClass('hidden');
    } else {
      this.updateShippingUrl(shippingLabelsContainer, selectedAmendment, selectedAmendmentQrCode, selectedAmendmentLabel)
      $('.current-price,.price-offer').addClass('hidden');
      $('.amendment-price').removeClass('hidden');
    }

    if (selectedDispatchedStatus == 'all' && selectedAmendment == 'original-order') {
      this.showAllItems();
    } else {
      order_item_rows.each((_, order_item_row) => {
       this.filterAmendedDetails(selectedDispatchedStatus, selectedAmendment)
       let showRow = this.showRow(selectedDispatchedStatus, selectedAmendment, order_item_row);

       if (showRow == true) {
         $(order_item_row).closest('.flex-tr').removeClass('hidden');
       } else {
          $(order_item_row).closest('.flex-tr').addClass('hidden');
       }
      });
    }

    this.hideSubOrderRow();
  }

  private filterAmendedDetails(selectedDispatchedStatus, selectedAmendment): void {
    let amendedDetails = $('.amendment-detail');

    amendedDetails.each((_, amendedDetail) => {
      let amendmentId = $(amendedDetail).data('amendmentId');
      let status = $(amendedDetail).data('returnReceived');

      if (amendmentId != selectedAmendment) {
        $(amendedDetail).addClass('hidden');
      } else {
        $(amendedDetail).removeClass('hidden');
      }

      let showOutstanding = selectedDispatchedStatus == 'outstanding';
      let showAll = selectedDispatchedStatus == 'all';
      let showOriginalOrder = selectedAmendment == 'original-order';
      let itemNotReceived = status == 'not_received';
      let validAmendmentId = amendmentId == selectedAmendment || showOriginalOrder;


      if (showOutstanding && itemNotReceived && validAmendmentId) {
        $(amendedDetail).removeClass('hidden');
      }

      if (itemNotReceived && showOutstanding && validAmendmentId) {
        $(amendedDetail).removeClass('hidden');
      }

      if (!itemNotReceived && showOutstanding && validAmendmentId) {
        $(amendedDetail).addClass('hidden');
      }

      if (showAll && showOriginalOrder) {
        $(amendedDetail).removeClass('hidden');
      }
    });
  }

  private focusOrderLink(selectedOption): void {
    this.amendmentsFilter.each((_, order_filter) => {
      if ($(order_filter).data('amendment') == selectedOption) {
        $(order_filter).addClass('active');
      } else {
        $(order_filter).removeClass('active');
      }
    });
  }

  private showAllItems(): void {
    let order_item_rows = $('.order-suborders-td-product');
    let amendedDetails = $('.amendment-detail');

    order_item_rows.closest('.flex-tr').removeClass('hidden');
    amendedDetails.removeClass('hidden');
  }

  private filterOnItemRow(e): void {
    e.preventDefault();

    let itemRow = $(e.target).closest('.flex-tr');
    let amendmentId = itemRow.find('div.order-suborders-td-product').data('filterDataAmendedItemId');

    this.focusOrderLink(amendmentId);
    this.filterOrderAmendments(e);
  }

  private showRow(selectedDispatchedStatus, selectedAmendment, order_item_row): boolean {
    let amendmentId = $(order_item_row).data('filterDataAmendedItemId');
    let amendmentIds: Array<any> = $(order_item_row).data('filterDataOrderAmendmentIds');
    let dispatchedStatus = $(order_item_row).data('filterDataDispatchedStatus');
    let showOutstanding = selectedDispatchedStatus == 'outstanding';

    if (amendmentIds?.includes(selectedAmendment)) {
      return true;
    }

    if (showOutstanding && selectedAmendment == 'original-order') {
      return dispatchedStatus == false;
    }

    if (showOutstanding && dispatchedStatus == true) {
      return false;
    }

    return amendmentId == selectedAmendment;
  }

  private updateShippingUrl(shippingLabelsContainer, selectedAmendment, selectedAmendmentQrCode, selectedAmendmentLabel: boolean): void {
    if (!selectedAmendmentQrCode && !selectedAmendmentLabel) {
      shippingLabelsContainer.addClass('hidden');
      return
    }

    shippingLabelsContainer.removeClass('hidden');

    let newShippingLabelUrl = `/uk/returns/${selectedAmendment}/print`;
    shippingLabelsContainer.find('.order-amendments-print').attr('href', newShippingLabelUrl);

    let qrCode = shippingLabelsContainer.find('.order-amendments-qrcode');

    if (!!selectedAmendmentQrCode) {
      qrCode.attr('data-ajax', selectedAmendmentQrCode);
      qrCode.removeClass('hidden');
    } else {
      qrCode.addClass('hidden');
    }
  }
}
